import { md } from '@/utils/utils_html';

interface Props {
  children: React.ReactNode;
  borderType?: string;
}

export const CreditLimitRowWrapper: React.FC<Props> = ({ children, borderType = '' }) => {
  return (
    <div
      className={`${md('px-2 justify-start gap-2', 'px-5 justify-start')} 
      w-full min-h-[50px] flex justify-start items-center border-b border-component-border ${borderType}`}
    >
      {children}
    </div>
  );
};
